import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * Faixa em Cobranças, depois do 5º pagamento confirmado na mão no mês
 * (PLANO-RECEBIMENTO-AUTOMATICO.md, seção 6.1/6.3, T4.5): fechável, lembra
 * por 30 dias. Mesmo padrão de `lib/payment-account-draft.ts` — falha de
 * storage nunca trava a tela, só faz a faixa aparecer de novo.
 */
const DISMISSED_UNTIL_KEY = 'payments-charges-banner-dismissed-until';
const SNOOZE_DAYS = 30;

export async function loadChargesBannerDismissedUntil(): Promise<Date | null> {
  try {
    const raw = await AsyncStorage.getItem(DISMISSED_UNTIL_KEY);
    if (!raw) return null;
    const date = new Date(raw);
    return Number.isNaN(date.getTime()) ? null : date;
  } catch {
    return null;
  }
}

export async function dismissChargesBanner(): Promise<void> {
  try {
    const until = new Date(Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000);
    await AsyncStorage.setItem(DISMISSED_UNTIL_KEY, until.toISOString());
  } catch {
    // Fechar é conveniência: se não gravar, a faixa só volta a aparecer sempre.
  }
}
